$(function () {
    if( $('.partners__wrapper') ) {
        $( '.partners__wrapper' ).each(function() {
            var count = $(this).find('.partners__wrapper__line').length+1;
            if(count){
                $('.row .col--item:nth-child(1) span, .row .col--item:nth-child(2) span, .row .col--item:nth-child(3) span').css('height', (count*100)+'%');
            }
        });
    }

    if( $('.partners__wrapper__title') ) {
        $(window).on('scroll load', function() {
            let base = 5;
            var delay = base / 45;
            var pixels = base + window.scrollY * delay ;
            $('.partners__wrapper__title').css({
                'transform': 'translateY(-50%) translateX(-' + pixels + 'px)',
            })
        });
    }
});
